import PropTypes from "prop-types";
import React, { Component } from "react";
import { Card, CardBody, Col, Container, Label, Row, Alert } from "reactstrap";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Field, Form, Formik } from "formik";
import LoginHeader from './components/header';
import LoginFooter from './components/footer';
import { userDefinitionPasswordSendMail, userDefinitionNewPasswordApiError } from "../../store/actions";
import * as Yup from "yup";

import {
  ErrorModal,
  MessageBoxModal
} from "../../components/Common/CombinedComponents";

class PasswordChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recordList: [],
      record: {
        message: "",
        code: "",
        details: "",
        correlationId: "",
        validationResults: [],
      },
      messageBoxModal: false,
      emailAdress: "",
      buttonDisabled: false,
      errorModal: false,
    };

    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  handleValidSubmit(values) {
    const { onSendMailRecord } = this.props;
    this.setState({ emailAdress: values.email });
    this.setState({ buttonDisabled: true });

    onSendMailRecord(values.email);
  }

  componentDidMount() {
    this.props.apiError("");
  }

  componentDidUpdate(prevProps) {
    const { error, waitingRecordListUpdate } = this.props;
    const { record } = this.state;
    if (prevProps.error !== error) {
      if (error) {
        this.setState({ buttonDisabled: false })
        if (error.response && error.response.data != '') {  
          let a = JSON.parse(error.response.data);
          record.code = a.Code;
          record.message = a.Message;
        }
        else if (error) { 
          record.code = error.code;
          record.message = error.message;
        } else {
          record.code = "Unhandled Exeption";
          record.message = "Please contact with Administrator";
        }
        this.setState({ error: record });
        this.setState({ errorModal: true, error: error });
      }
    }

    if (prevProps.waitingRecordListUpdate !== waitingRecordListUpdate) {
      this.setState({ messageBoxModal: true });
    }
  }

  onLoginLinkClick = e => {
    e.preventDefault();
    this.setState({ messageBoxModal: false });
    this.props.history.push("/login");
  };

  render() {
    const { error, emailAdress, messageBoxModal, buttonDisabled } = this.state;
    const { t } = this.props;
    return (
      <React.Fragment>
        <MessageBoxModal
          messageText={this.props.t("sendMailAddressToChangeYourPassword")}
          messageDetailText={
            this.props.t("anConfirmEmailHasBeenSentTo") +
            " " +
            emailAdress
          }
          show={messageBoxModal}
          onCloseClick={this.onLoginLinkClick}
        />
        {error && (<ErrorModal errorMessage={error} onCloseModalClick={() => this.setState({ error: undefined, messageModal: false })} />)}
        <div className="auth-container">
          <LoginHeader pageTitle={t("login.authHeaderTitlepassword")} />
          <div className="auth-content">
            <div className="container">
              <div className="row align-items-strech">
                <div className="auth-form-area">
                  <div className="forgot-password-container">
                    <Row className="justify-content-center">
                      <div className="title">{t("login.passwordTitle")}</div>
                      <div className="subtitle">
                        {t("login.passwordSubTitle")}
                      </div>
                      <div className="text">{t("login.passwordText")}</div>
                      <div className="p-2">
                        <Formik
                          initialValues={{
                            email: "",
                          }}
                          validationSchema={Yup.object().shape({
                            email: Yup.string()
                              .strict(true)
                              .max(
                                50,
                                this.props.t("maxLengthError").format("50"),
                              )
                              .required(this.props.t("mustBe"))
                              .matches(
                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/,
                                this.props.t("invalidEmail")
                              ),
                          })}
                          enableReinitialize={true}
                          validateOnChange={true}
                          validateOnBlur={true}
                          onSubmit={values => {
                            this.handleValidSubmit(values)
                          }}
                        >
                          {({ errors, touched }) => (
                            <Form>
                              <Row className="form-item">
                                <Col lg={12} className="col-12">
                                  <div className="mb-3">
                                    <Label style={{ minWidth: "fit-content" }}>
                                      {this.props.t("login.passwordInputTitle")}
                                    </Label>
                                    <Field
                                      name="email"
                                      placeholder={t("login.passwordInputPlaceholder")}
                                      type="text"
                                      className={`form-control ${errors.email && touched.email ? "is-invalid" : ""}`}
                                    />
                                    <div className="formik-error-placeholder">
                                      {touched.email &&
                                        errors.email && (
                                          <div className="text-danger mb-3">
                                            {errors.email}
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </Col>
                                <Col lg={12} className="col-12">
                                  <div className="mt-3 d-grid">
                                    <br></br>
                                    <button
                                      className="login-button mx-auto"
                                      type="submit" disabled={buttonDisabled}
                                      style={{ backgroundColor: "#AB63BF", color: "#FAF3FD" }}
                                    >
                                      {this.props.t("sendMail")}
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <LoginFooter
            className="login-footer-container"
            text={t("login.footerText")}
          />
        </div>
      </React.Fragment>
    );
  }
}


PasswordChange.propTypes = {
  recordList: PropTypes.array,
  onSendMailRecord: PropTypes.func,
  className: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
  waitingRecordListUpdate: PropTypes.any,
  history: PropTypes.any,
};

const mapStateToProps = ({ userDefinitionPassword }) => ({
  error: userDefinitionPassword.error,
  waitingRecordListUpdate: userDefinitionPassword.waitingRecordListUpdate
});

const mapDispatchToProps = dispatch => ({
  onSendMailRecord: record => dispatch(userDefinitionPasswordSendMail(record)),
  apiError: error => dispatch(userDefinitionNewPasswordApiError(error)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(PasswordChange));
